<template>
    <Teleport to="body">
        <div class="transfer-modal">
            <div class="transfer-modal__overlay" @click="() => emit('close')" />
            <div class="transfer-modal__wrapper">
                <button class="transfer-modal__close" @click="() => emit('close')">
                    <NuxtIcon name="ri:close-line" />
                </button>
                <div class="transfer-modal__header">
                    <h5 class="transfer-modal__title">{{ transferChosen?.title }}</h5>
                </div>
                <div class="transfer-modal__content">
                    <div class="w-full items-center">
                        <LazyDynamicImage :blok="transferChosen" class="mx-auto w-6/12 mb-3" />
                    </div>
                    <p v-for="(chosen, index) in transferChosen?.content?.content" :key="index">
                        {{ chosen.content[0].text }}
                    </p>
                </div>
            </div>
        </div>
    </Teleport>
</template>

<script setup lang="ts">
import type { IL4TransferOption } from '~/types';

defineProps<{
    transferChosen: null | IL4TransferOption;
}>();
const emit = defineEmits<{
    (e: 'close'): void;
}>();
</script>

<style lang="postcss" scoped>
.transfer-modal {
    @apply fixed z-[100] w-full h-full left-0 top-0;
    &__overlay {
        @apply fixed z-0 w-full h-full left-0 top-0 bg-opacity-70;
    }
    &__wrapper {
        @apply relative z-10 bg-white pb-2.5 my-8 tablet:my-20 mx-1.5 sm:mx-auto min-w-[306px] max-w-[700px];
        border: 2px solid #4b1862;
        @apply rounded-md overflow-hidden;
    }
    &__header {
        @apply bg-primary pt-2.5 pb-3.5 px-7 relative;
    }
    &__title {
        @apply text-lg tablet:text-[22px] text-white font-bold leading-5 tablet:leading-7 pl-20 pr-16 relative flex pl-1;
    }
    &__content {
        @apply pt-3.5 pb-8 px-7 text-primary text-[15px];
        p + p {
            @apply mt-5;
        }
    }
    &__close {
        @apply z-10 absolute border-none top-2 right-2 overflow-hidden;

        .iconify {
            @apply w-[31px] h-[31px] inline-block bg-white;
        }
    }
}
</style>
